import type { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { useSetDroppableNodeRef } from '../contexts';

export const DroppableAssetActivator = ({ children }: PropsWithChildren) => {
  const setNodeRef = useSetDroppableNodeRef();
  return <ActivatorContainer ref={setNodeRef}>{children}</ActivatorContainer>;
};

const ActivatorContainer = styled.div`
  /* droppable styles (if any) here */
`;
